import { Component, Input, OnInit, signal } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { ChokesService } from '../../services/chokes.service';
import { Choke, ChokesUi } from '../../models/chokes.model';
import { Observable, lastValueFrom } from 'rxjs';
import { User } from 'src/app/core/components/user-admin-page/user-model';
import { Store } from '@ngneat/elf';
import { withUIEntities } from '@ngneat/elf-entities';
import { StorageKeys, StoreService } from 'src/app/core/services/store.service';
import { MediatorService } from 'src/app/shared/services/mediator.service';
import { DataSavedMessage } from 'src/app/shared/models/mediator-messages.model';

@Component({
    selector: 'app-chokes',
    templateUrl: './chokes.component.html',
    providers: [ConfirmationService],
    standalone: false
})
export class ChokesComponent implements OnInit {
  public selectedChoke: Choke[];
  public chokeData: any;
  public isLoading = signal<boolean>(false);
  public selectedChokeDetails$: Observable<any>;
  public emitInitialValueOnInit = false;
  public hideGerg = false;
  public user: User;

  private _isAddOrDelete: boolean;
  private _savedChoke: string;

  // State
  private _componentId: string;
  @Input() set componentId(value: string) {
    this._componentId = value;
    this.chokesStore = this._storeService.createStore(this.componentId, null ,withUIEntities<ChokesUi>());
  }
  get componentId(): string {
    return this._componentId;
  }
  public chokesStore: Store;

  constructor(
    private _confirmationService: ConfirmationService,
    private _chokesService: ChokesService,
    private _storeService: StoreService,
    private _messenger: MediatorService
  ) {}

  async ngOnInit(): Promise<void> {
    this.user = await this._storeService.get<User>(StorageKeys.USER);
    if (this.user) {
      const company = this.user.profile?.organization?.toLowerCase();
      if (company != "altus" && company != "harbour" && company != "baker" && company != 'omv' &&
         company != "bp" && company != "fervo" && company != "neptune" && company != "shell" &&
          company != "oxy" && company != "cop" && company != "ou" && company != "petronas" && 
          company != "inpexau" && company != "te" && company != "sage" && company != "ormat") {
        this.hideGerg = true;
      }
    }

    this.getData();
  }

  private async getData() {
    this.isLoading.set(true);
    this.chokeData = await lastValueFrom(this._chokesService.getChokes());

    this.selectedChoke = [];

    this.selectedChoke = this.chokeData?.chokes.length > 0 ? this.chokeData.chokes[this.chokeData.chokes.length - 1] : this.createChoke();
    this.selectedChokeDetails$ = new Observable(observer => observer.next(this.selectedChoke));

    this.isLoading.set(false);
  }

  public onAddChoke(): void {
    if (this.hideGerg || this._isAddOrDelete) {
      return;
    }
    this._isAddOrDelete = true;
    const choke = this.createChoke();
    this.chokeData.chokes.push(choke);
    this.selectedChoke = this.chokeData.chokes[this.chokeData.chokes.length - 1];
    this.selectedChokeDetails$ = new Observable(observer => observer.next(this.selectedChoke));
  }

  public createChoke(): Choke {
    const newChoke: Choke = {
      name: '',
      criticalLiquidFlowFactor: 0.75,
      criticalVaporFlowFactor: 0.75,
      pipingGeometryFactor: 1,
      flowCoefficientSchedule: [
        {
          percentOpen: 0.0,
          flowCoefficient: 0.0
        }
      ]
    };

    return newChoke;
  }

  public onChokeSelect(e: any) {
    const foundChoke = this.chokeData.chokes.find(x => x.name === e.value.name);
    this.selectedChoke = foundChoke;
    this.selectedChokeDetails$ = new Observable(observer => observer.next(this.selectedChoke));
  }

  public onDeleteChoke(choke: Choke): void {
    let index = this.chokeData.chokes.findIndex(x => x.name == choke.name);
    if (index == -1) {
      index = 0;
    }
    this._confirmationService.confirm({
      message: 'Are you sure that you want to delete the selected choke?',
      accept: () => {
        this.chokeData.chokes.splice(index, 1);
        this._isAddOrDelete = true;
        this.handleSaveChokes();
        this.selectedChoke = this.chokeData.chokes.length > 0 ? this.chokeData.chokes[this.chokeData.chokes.length - 1] : this.createChoke();
        this.selectedChokeDetails$ = new Observable(observer => observer.next(this.selectedChoke));
      }
    });
  }

  public async handleSaveChokes(): Promise<void> {
    await lastValueFrom(this._chokesService.updateChokes(this.chokeData.chokes));    
    this._messenger.publish(new DataSavedMessage('Chokes'));

    if (this._isAddOrDelete) {
      this.isLoading.set(true);
      this.chokeData = null;
      this.chokeData = await lastValueFrom(this._chokesService.getChokes());
      this._isAddOrDelete = false;
      this.isLoading.set(false);
    }

    let index = this.chokeData.chokes.findIndex(x => x.name == this._savedChoke);
    if (index == -1) {
      index = this.chokeData.chokes.length - 1;
    }
    this.selectedChoke = this.chokeData.chokes[index];
    this.selectedChokeDetails$ = new Observable(observer => observer.next(this.selectedChoke));
  }

  public saveChoke(e: any) {
    let index = this.chokeData.chokes.findIndex(x => x.name == e.name && x.criticalLiquidFlowFactor == e.criticalLiquidFlowFactor);
    if (index == -1) {
      index = this.chokeData.chokes.findIndex(x => x.name == e.name);
    }
    if (index == -1) {
      index = this.chokeData.chokes.length - 1;
    }
    this.chokeData.chokes[index] = e;
    this._savedChoke = e.name;

    this.handleSaveChokes();
  }
}

